/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




$(document).ready(function() {
    
    
  $('.product__accordion summary a').on('click', function(e){
     e.preventDefault();
     $('.product__accordion details').attr('open');
     if($(this).parents('.product__accordion').hasClass('active')){
       $(this).parents('.product__accordion').removeClass('active');
        $(this).parents('.product__accordion').find('.accordion__content').slideUp();
     }else{
       $('.product__accordion').removeClass('active');
       $('.product__accordion .accordion__content').slideUp();
       $(this).parents('.product__accordion').addClass('active');
       $(this).parents('.product__accordion').find('.accordion__content').slideDown();
     }
 
     
   });
 
 
   $('.accordian').click(function(){
 
     
     if($(this).hasClass('active')){
         $(this).removeClass('active');
 
     }
     else{
         $('.accordian').removeClass('active');
         $(this).addClass('active');
     }
 });
 
 
 // Get Variant Id 
 
 $(document).ready(function() {
   var newsletterBlockButton = document.querySelectorAll('.newsletter-block-signup.klaviyo_form_trigger');
 
  $(newsletterBlockButton).on('click', function(e){
   window._klOnsite = window._klOnsite || [];
   window._klOnsite.push(['openForm', 'SWKNA4']);
  });
 
 });
 
 
 $(document).ready(function() {
   // Attach event listener to a parent element
   $('body').on('click', '.ColorSwatch__Radio', function() {
     // Get data-variant-id from the clicked element
     var variantId = $(this).parent().children("input").data("variantId");
     var variantAvailable = $(this).parent().children("input").data("available");
     console.log(variantAvailable);
     // Find the button element relative to the clicked element
     var button = $(this).closest('.ProductItem__Info').find('button.ProductForm__AddToCart.product-item');
     var productItem = $(this).closest('.ProductItem__Wrapper');
     var label = '<div class="ProductItem__LabelList"><span class="ProductItem__Label ProductItem__Label--soldOut subtitle Heading Text--subdued">Out of Stock</span></div>'
     // Update the data-variant attribute after a short delay to allow for DOM updates
     setTimeout(function() {
       button.attr('data-variant', variantId);
       if (variantAvailable === false) {
         console.log("false", label);
         productItem.closest('.ProductItem__Wrapper').append(label);
         button.prop("disabled", true);
         button.text("Out of Stock");
       } else {
         button.prop("disabled", false);
         button.text("Add to Cart");
         productItem.find('.ProductItem__LabelList').remove();
       }
     }, 100);
   });
 });
 
 
 // Collection Add to Cart Button
 
 $(document).on('click', 'button.ProductForm__AddToCart.product-item', function() {
   var ID = $(this).attr("data-variant");
   addItemToCart(ID, 1);
 });
 function addItemToCart(variant_id, qty) {
   data = {
     "id": variant_id,
     "quantity": qty
   }
   jQuery.ajax({
     type: 'POST',
     url: '/cart/add.js',
     data: data,
     dataType: 'json',
     success: function() { 
       document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         bubbles: true,
         detail: {
           variant: variant_id,
           quantity: qty
         }
       }));
       
     }   
     
   }); 
  
 }
 
 $('.ProductList.ProductList--grid.Grid').on('change', function() {
   $('button.ProductForm__AddToCart.product-item').click(function(){    
     var ID = $(this).attr("data-variant");
     addItemToCart( ID, 1);
   
   });
 })
 
 
 
 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    var swatchImages = document.querySelectorAll('.Product__SlideItem.Product__SlideItem--image');
    var previewImages = document.querySelectorAll('.Product__SlideshowNavImage');
 
 
 
     swatchImages.forEach(elem => {
       if (elem.getAttribute('data-alt') == variant.title) {
         elem.classList.add('active');
       }
       else {
         elem.classList.remove('active');
       }
     });
     
     previewImages.forEach(elem => {
       if (elem.getAttribute('data-variant') == variant.title) {
         elem.classList.add('active');
       }
       else {
         elem.classList.remove('active');
       }
     })
 
     });
 });
     
 
 // Footer Accordion
 
 $(document).ready(function() {
   $('.Footer__Title').on('click', function(e){
     e.preventDefault();
 
     if($(this).parents('.Footer__Block').hasClass('active')){
       $(this).parents('.Footer__Block').removeClass('active');
       $('.Footer__Block .LinkList').slideUp();
     }else{
 
       $(this).parents('.Footer__Block').addClass('active');
       $('.Footer__Block .LinkList').slideUp().slideDown();
     }
   });
 });
 
 
 // Cart Dynamic Buttons
 
 window.onload = function () {
   var element = document.querySelector('.dynamic-checkout__content');
 
   if (element) {
       // check if the element has any child nodes
       if (element.childNodes.length === 0) {
           // hide the element if it has no child nodes
           element.style.display = 'none';
       }
   }
 };
 
 
   
 // Product Add on 
 
 document.addEventListener('product:added', function(event) {
 
   let addons = $('.addon_add:checked');
   
   if (addons.length) {
       
       let itemsToAdd = [];
 
       $.each(addons, function(index, item) {
         itemsToAdd.push({
             id: $(item).val(),
             quantity: 1
         });
         $(item).prop('checked', false);
       });
 
       $.post('/cart/add.js', {
           items: itemsToAdd
         }, function(data) {
           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
               bubbles: true
             }));
         }, "json");
   }
   
 });
 
 // let reviewContainer = document.querySelector('.stamped-main-badge')
 
 // document.addEventListener('DOMContentLoaded', function() {
 
 //   setTimeout(function() {
 //     if(reviewContainer){
 //       // reviewContainer.style.display = 'none';
 //       const reviewCount = document.querySelector('.stamped-badge-caption').dataset.reviews;
 //       if(reviewCount < 5){
 //         reviewContainer.style.display = 'none';
 //     }
 //     }
 //   }, 500);
 // });
 
 
 
 // Variant Addons
 document.addEventListener('product:added', function(event) {
 
  let variantAddon = $('.variant-list-container').filter(function() {
   let selected = $(this).attr('data-selected');
   return selected && selected !== 'none';
 });
 
 if (variantAddon.length) {
 
   let itemsToAdd = [];
 
   $.each(variantAddon, function(index, item) {
     let variantId = $(item).attr('data-selected');
 
     itemsToAdd.push({
       id: variantId,
       quantity: 1
     });
 
     $(item).prop('checked', false);
   });
 
   $.post('/cart/add.js', {
     items: itemsToAdd
   }, function(data) {
     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
       bubbles: true
     }));
   }, "json");
 }
 });
 

 
$(document).ready(function(){
  if($('.ProductForm__Variants.ProductForm__Variants--bundles').length > 0){
  var bcpoObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if(node.id === 'bcpo'){
          $('.ProductForm__Variants.ProductForm__Variants--bundles').removeClass('has-loading-animation');
          bcpoObserver.disconnect();
        }
      });
    });
  });

  bcpoObserver.observe(document.querySelector('.ProductForm__Variants.ProductForm__Variants--bundles'), {
    childList: true,
    subtree: true
  });


  setTimeout(function(){
    $('.ProductForm__Variants.ProductForm__Variants--bundles').removeClass('has-loading-animation');
  }, 5000);

  }



  // Video Updated
  let updatedVideoContainer = document.querySelector('.video-updated--content-video');
  if(updatedVideoContainer){
    let video = updatedVideoContainer.querySelector('video');
    let playButton = updatedVideoContainer.querySelector('.video-play--container');
    if(video){
      playButton.addEventListener('click', function(){
        video.play();
        playButton.classList.add('hide');
      });
    }
  }

  

  const eyes = document.querySelectorAll('.logo-eyes');


  // Register GSAP plugins


  // Define eye paths for blinking animation
  const openPath = "M5,15 Q50,0 95,15 Q50,30 5,15";
  const closedPath = "M5,15 Q50,15 95,15 Q50,15 5,15";


  // Blink using scaleY (no morphing)
  function blink() {
    gsap.to(eyes, {
      duration: 0.15,
      scaleY: 0.1,
      transformOrigin: "center",
      ease: "power1.inOut",
      onComplete: () => {
        gsap.to(eyes, {
          duration: 0.15,
          scaleY: 1,
          transformOrigin: "center",
          ease: "power1.inOut"
        });
      }
    });
  }

  // Loop just the blink
  function animateLoop() {
    blink();
    setTimeout(animateLoop, 3000);
  }

  animateLoop();

  // Mouse-follow logic for pupils

});
